import React, { useState, useRef, useEffect } from 'react';

const useClickOutside = (ref, onClose) => {
  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [ref, onClose]);
};

export default function SuggestedInteractionsDropdown({ trigger, children, onOpenChange, close }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useClickOutside(ref, () => setOpen(false));

  const handleOpenChange = (value) => {
    setOpen(value);
    onOpenChange(value);
  };

  useEffect(() => {
    setOpen(close);
  }, [close]);

  return (
    <div className="relative inline-block" ref={ref}>
      <div onClick={() => handleOpenChange(!open)} className="cursor-pointer">
        {trigger}
      </div>

      {open && (
        <div className="absolute left-0 mt-2 w-[380px] py-3 bg-transparent rounded-xl z-50 animate-fade-in">
          {children}
        </div>
      )}
    </div>
  );
}
